// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__15-fC","button__text":"styles_button__text__2Pxze","disabled":"styles_disabled__1hm9v"};